// content 为 当前模块对象 data为调用该函数时传递的对象 外面使用dispatch("函数名称", data)方法调用这里的函数
import scriptjs from 'scriptjs';

const fetchScript = function (url) {
  return new Promise((resolve) => {
    scriptjs(url, () => {
      resolve()
    })
  })
}

export function loadJs () {
  (async () => {
      await fetchScript('/static/js/editor.md/jquery-1.11.3.min.js');
      await fetchScript('/static/js/editor.md/lib/marked.min.js')
      await fetchScript('/static/js/editor.md/lib/prettify.min.js')
      await fetchScript('/static/js/editor.md/lib/raphael.min.js')
      await fetchScript('/static/js/editor.md/lib/underscore.min.js')
      await fetchScript('/static/js/editor.md/lib/sequence-diagram.min.js')
      await fetchScript('/static/js/editor.md/lib/flowchart.min.js')
      await fetchScript('/static/js/editor.md/lib/jquery.flowchart.min.js')
      await fetchScript('/static/js/editor.md/editormd.min.js');
      // await this.fetchScript('/static/js/highlight/highlight.min.js')
  })()
}
export default{
    loadJs:loadJs
}



// WEBPACK FOOTER //
// ./src/common/actions.js